import { HTMLAttributes } from 'react'
import { ChildrenProp } from '../types_and_interfaces.ts'
import { cn } from '../utilities.ts'

type FormProps = HTMLAttributes<HTMLFormElement> & ChildrenProp

export const Form = ({ className, children, ...props }: FormProps) => {
  return (
    <form className={cn('w-full', className)} {...props}>
      {children}
    </form>
  )
}
